import {Course} from '@udemy-v2/browse-course';

export function useCourseIncludesRolePlay(course: Course) {
    const numRolePlays = course?.curriculum?.contentCounts?.rolePlaysCount ?? 0;
    const numGradedRolePlays = course?.curriculum?.contentCounts?.gradedRolePlaysCount ?? 0;
    return {
        numRolePlays,
        hasRolePlay: numRolePlays > 0,
        numGradedRolePlays,
        hasGradedRolePlay: numGradedRolePlays > 0,
    };
}
